module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__stock__worker",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('z-input-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.users,
      "callback": _vm.suggestUsers,
      "show-on-focus": true,
      "data-vv-name": "user",
      "data-vv-as": ' ',
      "name": "user",
      "id": "id",
      "display-property": "login",
      "property": "id",
      "return": "id",
      "label": "ФИО, логин или email",
      "default": "",
      "required": true
    },
    model: {
      value: (_vm.user),
      callback: function($$v) {
        _vm.user = $$v
      },
      expression: "user"
    }
  }), _vm._v(" "), _c('p', [_vm._v(" Внимание! Если пользователь уже прикреплён к складу, он не будет отображаться в списке, в поле выше. ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acb3ac0a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/StockWorker.vue
// module id = 1237
// module chunks = 0